import styled from 'styled-components';

import variables from '../../../styles/variables';

interface Props {
  readonly selectedStorageSize?: string;
  readonly size?: string;
}

export const StorageOptions = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: nowrap;
  list-style: none;
  margin: 0;
  padding: 0;
  justify-content: flex-start;
`;

// prettier-ignore
export const Storage = styled.button<Props>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  width: 68px;
  height: 29px;
  border-radius: 5px;
  border: 1px solid ${variables.colorBlack};
  margin: 0;
  margin-right: 15px;
  font-size: 12px;
  cursor: pointer;
  &:hover {
    background: ${variables.colorBlack};
    color: #FFF;
  }
  ${props => (props.selectedStorageSize === props.size ? `
      background: #333333;
      color: #FFF;
      `
    : null)
}
`;
